import { useState } from "react";
import { Link } from "react-router-dom";
import { Copy, ExternalLink, Eye, Share2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export function FundingShare({ check, onChange }) {
  const [busy, setBusy] = useState(false);
  const on = !!check.share_enabled;
  const url = check.share_id ? `${window.location.origin}/funding-ready/${check.share_id}` : "";
  const toggle = async (enabled) => {
    setBusy(true);
    try { const r = await api.put(`/eligibility/${check.check_id}/share`, { enabled }); onChange({ ...check, ...r.data }); toast.success(enabled ? "Share link is on" : "Share link turned off"); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  const copy = () => navigator.clipboard.writeText(url).then(() => toast.success("Link copied"));
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-5" data-testid="funding-share">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <div className="flex items-start gap-3"><Share2 className="h-5 w-5 text-emerald-600 mt-0.5" />
          <div><h3 className="font-semibold text-slate-900">Share your Funding Ready status</h3>
            <p className="text-xs text-slate-500">Banks and sponsors see your business name, score and the names of verified documents. Files are never shared.</p>
            <p className="text-xs text-slate-500">Set your business name in <Link to="/dashboard/company" className="text-emerald-700 hover:underline" data-testid="funding-share-company-link">Company profile</Link> so it shows on the page.</p></div></div>
        <label className="flex items-center gap-2 text-sm text-slate-700"><Switch checked={on} disabled={busy} onCheckedChange={toggle} data-testid="funding-share-toggle" />{on ? "On" : "Off"}</label>
      </div>
      {on && url && (
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <code className="flex-1 min-w-0 truncate text-xs bg-slate-50 border border-slate-200 rounded px-3 py-2" data-testid="funding-share-url">{url}</code>
          <button onClick={copy} className="inline-flex items-center gap-1 text-sm font-medium text-emerald-700 hover:underline" data-testid="funding-share-copy"><Copy className="h-4 w-4" />Copy</button>
          <a href={`${url}?preview=1`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-medium text-slate-600 hover:underline" data-testid="funding-share-open"><ExternalLink className="h-4 w-4" />Preview</a>
          <p className="w-full text-xs text-slate-500 flex items-center gap-1" data-testid="funding-share-views"><Eye className="h-3.5 w-3.5" />
            {check.share_views ? `Opened ${check.share_views} time${check.share_views === 1 ? "" : "s"} · last opened ${new Date(check.share_last_viewed).toLocaleString()}` : "Not opened yet"} <span className="text-slate-400">(your previews don't count)</span></p>
        </div>
      )}
    </div>
  );
}
